export const definedTranslation = {
  miniPDP: {
    detailsButtonLabel: {
      id: 'catalog-mini-pdp-learn-more-button',
      defaultMessage: 'Learn more',
    },
    contactRepButtonLabel: {
      id: 'catalog-mini-pdp-contact-rep-button',
      defaultMessage: 'Contact rep',
    },
    infoBrandLabel: {
      id: 'catalog-mini-pdp-brand-label',
      defaultMessage: 'Brand',
    },
    infoUsageLabel: {
      id: 'catalog-mini-pdp-usage-label',
      defaultMessage: 'Usage',
    },
    infoSkuLabel: {
      id: 'catalog-mini-pdp-sku-label',
      defaultMessage: 'SKU',
    },
    indoorOutdoorLabel: {
      id: 'catalog-mini-pdp-indoor-outdoor-label',
      defaultMessage: 'Indoor / Outdoor',
    },
    sizeLabel: {
      id: 'catalog-mini-pdp-size-label',
      defaultMessage: 'Size',
    },
    noteLabel: {
      id: 'catalog-mini-pdp-note-label',
      defaultMessage: 'Note',
    },
    createProjectButtonLabel: {
      id: 'catalog-create-project-button',
      defaultMessage: 'Create Project',
    },
    filesHeadline: {
      id: 'catalog-mini-pdp-files-headline',
      defaultMessage: 'Files',
    },
    more: {
      id: 'catalog-mini-pdp-more-button',
      defaultMessage: 'more',
    },
    showAll: {
      id: 'catalog-mini-pdp-show-all-button',
      defaultMessage: 'Show All',
    },
    collapse: {
      id: 'catalog-mini-pdp-collapse-button',
      defaultMessage: 'Collapse',
    },
    download: {
      id: 'catalog-mini-pdp-download-button',
      defaultMessage: 'Download',
    },
  },
  quickView: {
    variationsLabel: {
      id: 'catalog-mini-pdp-variations-label',
      defaultMessage: 'Colorways',
    },
    detailsButtonLabel: {
      id: 'catalog-mini-pdp-learn-more-button',
      defaultMessage: 'Learn more',
    },
    projectPreLabel: {
      id: 'catalog-project-selector-label',
      defaultMessage: 'Project',
    },
    addToCartButtonLabel: {
      id: 'catalog-material-add-to-cart-button',
      defaultMessage: 'Add to Cart',
    },
    createProjectButtonLabel: {
      id: 'catalog-create-project-button',
      defaultMessage: 'Create Project',
    },
    contactRepButtonLabel: {
      id: 'catalog-contact-rep-button',
      defaultMessage: 'Contact Rep',
    },
    config: {
      sizesLabel: {
        id: 'catalog-quick-view-config-sizes',
        defaultMessage: 'Sizes',
      },
      finishesLabel: {
        id: 'catalog-quick-view-config-finishes',
        defaultMessage: 'Finishes',
      },
      thicknessesLabel: {
        id: 'catalog-quick-view-config-thicknesses',
        defaultMessage: 'Thicknesses',
      },
      substratesLabel: {
        id: 'catalog-quick-view-config-substrates',
        defaultMessage: 'Substrates',
      },
    },
  },
  projectMessages: {
    projectUpdated: {
      id: 'catalog-project-updated-message',
      defaultMessage: 'Current project successfully updated',
    },
    projectAdded: {
      id: 'catalog-project-added-message',
      defaultMessage: 'Project Successfully Added',
    },
    errorProjectSet: {
      id: 'catalog-error-project-set',
      defaultMessage: 'Cannot set current project',
    },
  },
  pricingTooltip: {
    actionButtonLabel: {
      id: 'catalog-mini-pdp-pricing-tooltip-action-button',
      defaultMessage: 'Pricing & quote',
    },
    priceLabel: {
      id: 'catalog-mini-pdp-pricing-tooltip-price-label',
      defaultMessage: 'Price',
    },
    subtitle: {
      id: 'catalog-mini-pdp-pricing-tooltip-subtitle',
      defaultMessage: 'Confirm your project details',
    },
    selectPlaceholder: {
      id: 'catalog-mini-pdp-pricing-tooltip-select-placeholder',
      defaultMessage: 'Select project',
    },
    inputPlaceholder: {
      id: 'catalog-mini-pdp-pricing-tooltip-input-placeholder',
      defaultMessage: 'Intended purchasing quantity',
    },
    submitButtonLabel: {
      id: 'catalog-mini-pdp-pricing-tooltip-submit-button',
      defaultMessage: 'Request quote',
    },
    successMessage: {
      title: {
        id: 'catalog-mini-pdp-pricing-tooltip-success-title',
        defaultMessage: 'Your request has been submitted',
      },
      subtitle: {
        id: 'catalog-mini-pdp-pricing-tooltip-success-subtitle',
        defaultMessage:
          'Thanks for submitting! Our brand partner will provide a quote as soon as possible',
      },
      closeButtonLabel: {
        id: 'catalog-mini-pdp-pricing-tooltip-success-close-button-label',
        defaultMessage: 'Close',
      },
      submitButtonLabel: {
        id: 'catalog-mini-pdp-pricing-tooltip-success-submit-button-label',
        defaultMessage: 'Go to Inbox',
      },
    },
    errorSubmittingQuote: {
      id: 'catalog-mini-pdp-pricing-tooltip-error-submitting-quote',
      defaultMessage: 'Error submitting quote',
    },
  },
  FeltColors: {
    id: 'FeltColors',
  },
  MetalFinish: {
    id: 'MetalFinish',
  },
  Rope: {
    id: 'Rope',
  },
  Wood: {
    id: 'Wood',
  },
  WoodFinish: {
    id: 'WoodFinish',
  },
  Fabrics: {
    id: 'Fabrics',
  },
  Lacquer: {
    id: 'Lacquer',
  },
  Rattan: {
    id: 'Rattan',
  },
};
